export const AUTH_TOKEN_KEY = 'token';
